import api from './api/api';

export const getProfilePicture = async () => {
  const response = await api(process.env.VUE_APP_PARAMETRIZAVEL_URL)
    .get('/profile/picture')
    .catch(() => Promise.resolve());

  return response;
};
